import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraphicEq = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1536 1312V192Q1536 142 1502.0 103.0Q1468 64 1416.0 42.5Q1364 21 1312.5 10.5Q1261 0 1216.0 0.0Q1171 0 1119.5 10.5Q1068 21 1016.0 42.5Q964 64 930.0 103.0Q896 142 896.0 192.0Q896 242 930.0 281.0Q964 320 1016.0 341.5Q1068 363 1119.5 373.5Q1171 384 1216 384Q1321 384 1408 345V882L640 645V-64Q640 -114 606.0 -153.0Q572 -192 520.0 -213.5Q468 -235 416.5 -245.5Q365 -256 320.0 -256.0Q275 -256 223.5 -245.5Q172 -235 120.0 -213.5Q68 -192 34.0 -153.0Q0 -114 0.0 -64.0Q0 -14 34.0 25.0Q68 64 120.0 85.5Q172 107 223.5 117.5Q275 128 320 128Q425 128 512 89V1056Q512 1087 531.0 1112.5Q550 1138 580 1148L1412 1404Q1424 1408 1440 1408Q1480 1408 1508.0 1380.0Q1536 1352 1536 1312Z"
	})
});
export default SvgGraphicEq;
